import React from "react";
import { Meta } from "../layout/Meta";
import RequireAuth from "../auth/RequireAuth";
import { AccountProvider } from "./AccountProvider";
import AccountMenu from "./AccountMenu";

export default function AccountLayout({
  title,
  description,
  path,
  children,
  allowClosing = false,
  allowAnonymousReceipt = false,
}) {
  return (
    <RequireAuth allowClosing={allowClosing} allowAnonymousReceipt={allowAnonymousReceipt}>
      <AccountProvider>
        <Meta title={title} description={description} path={path} noindex />
        <div className="mx-auto w-full max-w-[1200px] px-4 py-10 md:px-8 md:py-12">
          <div className="md:flex md:gap-10">
            <aside className="mb-8 w-full shrink-0 md:mb-0 md:w-[220px]">
              <p className="text-xs font-semibold uppercase tracking-wide text-muted">Your Stratify account</p>
              <h1 className="mt-2 text-3xl font-semibold tracking-tight text-ink">{title}</h1>
              <AccountMenu className="mt-6 hidden md:block" />
            </aside>
            <div className="min-w-0 flex-1">{children}</div>
          </div>
          <div className="mt-10 md:hidden">
            <AccountMenu />
          </div>
        </div>
      </AccountProvider>
    </RequireAuth>
  );
}
